import ReactSnackBar from 'react-js-snackbar';

const SnackBar = (props) => {
    return (
        <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999 }}>
            <ReactSnackBar {...props} />
        </div>
    );
};

export default SnackBar;
